import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Discuss from '../entities/discuss'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface DiscussState extends ListState<Discuss> {
    editDiscuss: Discuss;
}
class DiscussModule extends ListModule<DiscussState, any, Discuss>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Discuss>(),
        loading: false,
        editDiscuss: new Discuss(),
    }
    actions = {
        async getAll(context: ActionContext<DiscussState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Discuss/GetAll', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<Discuss>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },        
        async create(context: ActionContext<DiscussState, any>, payload: any) {
            await Ajax.post('/api/services/app/Discuss/Create', payload.data);
        },
        async update(context: ActionContext<DiscussState, any>, payload: any) {
            await Ajax.put('/api/services/app/Discuss/Update', payload.data);
        },
        async delete(context: ActionContext<DiscussState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Discuss/Delete?Id=' + payload.data.id);
        }, 
        async auditedDiscuss(context: ActionContext<DiscussState, any>, payload: any) {
            await Ajax.post('/api/services/app/Discuss/auditedDiscuss?id=' + payload.data.id);
        },        
        async get(context: ActionContext<DiscussState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Discuss/Get?Id=' + payload.data.id);
            context.state.editDiscuss=reponse.data.result as Discuss;
        }
    };
    mutations = {
        setCurrentPage(state: DiscussState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: DiscussState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: DiscussState, discuss: Discuss) {
            state.editDiscuss = discuss;
        }
    }
}
const discussModule = new DiscussModule();
export default discussModule;